<template>
  <div>
    <el-table :data="projects" default-expand-all>
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="pair" label="交易对"></el-table-column>
      <el-table-column label="余额">
        <template slot-scope="scope">
          <div>
            {{ scope.row.coinAmount }}
            {{ scope.row.coinType }}
          </div>
          <div>{{ scope.row.setCoinAmount }} {{ scope.row.setCoinType }}</div>
        </template>
      </el-table-column>
      <el-table-column label="冻结数量">
        <template slot-scope="scope">
          <div>
            {{ scope.row.coinFroze }}
            {{ scope.row.coinType }}
          </div>
          <div>{{ scope.row.setCoinFroze }} {{ scope.row.setCoinType }}</div>
        </template>
      </el-table-column>
      <el-table-column label="借币数量">
        <template slot-scope="scope">
          <div>
            {{ scope.row.coinBorrow }}
            {{ scope.row.coinType }}
          </div>
          <div>{{ scope.row.setCoinBorrow }} {{ scope.row.setCoinType }}</div>
        </template>
      </el-table-column>
      <el-table-column label="利息">
        <template slot-scope="scope">
          <div>
            {{ scope.row.coinInterest }}
            {{ scope.row.coinType }}
          </div>
          <div>{{ scope.row.setCoinInterest }} {{ scope.row.setCoinType }}</div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';

export default {
  name: 'lever',
  data() {
    return {
      showUserDialog: false
    };
  },
  computed: {
    ...mapState('leverRecord', ['projects', 'pagination', 'totalCount'])
  },
  components: {
    Detail,
    Pagination
  },
  methods: {
    ...mapMutations('leverRecord', ['setEditingProject']),
    edit(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    getUserDetail(uid) {
      this.nowUserId = uid;
      this.showUserDialog = true;
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
